export function matchesBoolean(matchValue) {
  return val => val !== undefined && val.toString() === matchValue.toString();
}

export function matchesString(matchValue) {
  return val => val === matchValue;
}

export function matchesInt(matchValue) {
  return val => val === matchValue;
}

export function includesVal(matchValue) {
  return val => val && val.includes(matchValue);
}



// WEBPACK FOOTER //
// ./app/lib/filters.js